
export const reducerSetActiveChatId = (state, {chatId}) => {
  return {
    ...state,
    activeChatId: chatId,
  };
}
